<template>
    <v-app>
        <div id="app">
            <nav>
                <navigation-bar v-if="isLoggedIn" />
            </nav>
            <router-view class="universal-padding" />
        </div>
    </v-app>
</template>

<script>
    import NavigationBar from '@/components/NavigationBar'
    export default {
        name: 'App',
        components: {
            NavigationBar
        },
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn
            },
            jwtToken() {
                return this.$store.getters.getToken
            }
        }
    }

</script>

<style>
#app {
    color: #2c3e50;
    background: #ebecf0;
}

.universal-padding {
    padding: 20px;
    height: calc(100% - 30px);
    overflow-y: auto;
}

.desktop-only {
    display: none !important;
}

.mobile-only {
    display: flex !important;
}

@media screen and (min-width: 992px) {
    .desktop-only {
        display: contents !important;
    }

    .mobile-only {
        display: none !important;
    }
}
</style>

<style scoped>
nav {
    padding: 30px;
    position: sticky;
    z-index: 1;
    top: 0;
    height: 30px;
}
</style>
